import { useRef } from 'react';
import { createPortal } from 'react-dom'
import styled from 'styled-components';
import { ChevronLeft, X } from 'lucide-react'
import breakpoints from 'theme/breakpoints';
import ticketsApi from 'api/requests/tickets'
import Button from 'components/_UI/Button';
import QRReader from 'components/commons/QRReader';

export default function TicketValidationModal({
  isOpen,
  onClose = () => false,
  onSucess = () => false,
  onError = () => false,
}) {
  const readerRef = useRef(null);

  const videoStyles = {
    height: '50%',
    width: '80%',
    zIndex: '1',
  }

  const handleScanFile = (result) => {
    if (result) {
      readerRef.current?.stop();
      validateTicket(result);
    }
  };

  async function validateTicket(code) {
    try {
      const { data } = await ticketsApi.checkIn({ code });
      onSucess(data?.data);
    } catch (error) {
      onError(error);
    } finally {
      onClose();
    }
  }

  return (
    <>
      {
        isOpen &&
        createPortal(
          <ScannerContainer>
            <VideoContainer>
              <BackButton onClick={onClose}>
                <ChevronLeft size={32} />
              </BackButton>
              <QRReader
                ref={readerRef}
                onScanSuccess={handleScanFile}
                containerStyles={videoStyles}
              />
              <InstructionText>Aponte a câmera para o QR Code</InstructionText>
              <Button
                marginTop='1rem'
                marginBottom='0'
                category='minimal'
                style={{ width: 'fit-content' }}
                onClick={onClose}
              >
                <X size={32}></X>
              </Button>
            </VideoContainer>
          </ScannerContainer>,
          document.body
        )
      }
    </>
  )
}

const ScannerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: rgba(26, 26, 26, .9);
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`

const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;

  @media screen and (min-width: ${breakpoints.md}) {
    max-width: 35%;
    margin: 0 auto;
  }
`

const InstructionText = styled.p`
  color: white;
  font-size: 18px;
  text-align: center;
  margin-top: 2rem;
  max-width: 80%;
  font-weight: 500;
`

const BackButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  background: transparent;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
`